"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWrapper = void 0;
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var StyledTextfield = (0, styled_1.default)('input')(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        '::selection': {
            backgroundColor: (_b = theme.palette.azzurro) === null || _b === void 0 ? void 0 : _b.contrastText,
        },
        color: theme.palette.riverstone,
        fontSize: 'inherit',
        lineHeight: 'inherit',
        border: 'none',
        background: 'none',
        width: '100%',
        display: 'block',
        resize: 'none',
        padding: 0,
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(StyledTextfield, {
    readonly: true,
    type: 'text',
});
exports.InputWrapper = (0, styled_1.default)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        fontSize: theme.typography.body1.fontSize,
        lineHeight: '20px',
        padding: theme.spacing(0.5, 0, 0.5, 1.5),
        position: 'relative',
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
        cursor: 'text',
        flex: '1 1 0%',
        backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.light,
        height: 28,
    });
});
